export default __webpack_public_path__ + "static/media/pulse_hump_inverse.c86a65fd.svg";